{{ profile | json }}

<div class="content-center">
	<button class="btn" (click)="redirectToAuthorize()">Mit Spotify verbinden</button>
</div>
